<template>
  <NuxtLink
    :to="props.external ? props.link : localePath(props.link)"
    class="inline-flex items-center justify-center rounded-md border border-ng70 bg-ng20 px-5 py-[13px] font-medium uppercase leading-[1.2] tracking-[0.08em] shadow-btn hover:bg-ng100 focus:bg-ng100 active:bg-ng100 disabled:opacity-60"
    :target="props.external ? '_blank' : ''"
    :rel="props.external ? 'noopener noreferrer' : ''"
  >
    {{ props.text }}
    <Icon class="ml-4" name="prime:external-link" />
  </NuxtLink>
</template>

<script lang="ts" setup>
const props = defineProps({
  text: {
    type: String,
    required: true,
  },
  link: {
    type: [String, Object],
    required: true,
  },
  external: {
    type: Boolean,
    default: false,
  },
});
const localePath = useLocalePath();
</script>
<style lang="scss" scoped></style>
